<template>
  <form class="return-authorisation-form" @submit.prevent="submit">

    <div class="columns">
      <div class="column">
        <validation-field label="I am the">
          <div class="block">
            <b-radio v-model="editRa.customer_type" native-value="customer" :disabled="!editable">End User</b-radio>
            <b-radio v-model="editRa.customer_type" native-value="dealer" :disabled="!editable">Dealer</b-radio>
          </div>
        </validation-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <validation-field label="Please select a product you need support for" :validation="selectedProductValidation">
          <b-select v-model="selectedProduct" placeholder="Select a product" :size="sizeClass" @focus="selectedProductValidation.msg = ''" :disabled="!editable" expanded>
            <option v-for="item in products" :value="item.name" :key="item.id">{{ item.name }}</option>
          </b-select>
        </validation-field>
        <validation-field :validation="validation.product" v-if="selectedProduct === 'Other'">
          <b-input v-model="product" placeholder="Other product" :size="sizeClass" @focus="focussed('product')" :disabled="!editable" />
        </validation-field>
        <validation-field label="Serial Number (Only leave this field blank if it is unknown).
For indash units the serial can be found on your original box.">
          <b-input v-model="editRa.serial_number" placeholder="Serial Number" :size="sizeClass" :disabled="!editable" />
        </validation-field>
        <validation-field label="Date Purchased" :validation="validation.date_purchased">
           <b-datepicker
            @focus="focussed('date_purchased')"
            v-model="datePurchased"
            :size="sizeClass"
            :date-formatter="d => $moment(d).format('DD/MM/YYYY')"
            :max-date="new Date()"
            placeholder="Date Purchased"
            icon="calendar"
            icon-pack="fas"
            :disabled="!editable">
          </b-datepicker>
        </validation-field>
      </div>
      <div class="column">
        <validation-field label="Dealer Purchased From" :validation="selectedDealerValidation">
          <b-select v-model="selectedDealer" placeholder="Select a dealer" :size="sizeClass" @focus="selectedDealerValidation.msg = ''" :disabled="!editable" expanded>
            <option v-for="item in dealers" :value="item.name" :key="item.id">{{ item.name }}</option>
          </b-select>
        </validation-field>
        <validation-field :validation="validation.dealer" v-if="selectedDealer === 'Other'">
          <b-input v-model="dealer" placeholder="Other dealer" :size="sizeClass" @focus="focussed('dealer')" :disabled="!editable" />
        </validation-field>

        <!-- <validation-field label="Dealer Purchased From" :validation="validation.dealer">
          <b-select v-model="editRa.dealer" placeholder="Select a dealer" :size="sizeClass" @focus="focussed('dealer')" expanded>
            <option v-for="item in dealers" :value="item" :key="item">{{ item }}</option>
          </b-select>
        </validation-field> -->
        <validation-field label="Invoice Number (Issued by dealer to customer)" :validation="validation.invoice_number">
          <b-input placeholder="Invoice Number" v-model="editRa.invoice_number" :size="sizeClass" @focus="focussed('invoice_number')" :disabled="!editable" />
        </validation-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <validation-field label="First Name" :validation="validation.first_name">
          <b-input v-model="editRa.first_name" placeholder="First Name" :size="sizeClass" @focus="focussed('first_name')" :disabled="!editable" />
        </validation-field>
      </div>
      <div class="column">
        <validation-field label="Family Name" :validation="validation.family_name">
          <b-input v-model="editRa.family_name" placeholder="Family Name" :size="sizeClass" @focus="focussed('family_name')" :disabled="!editable" />
        </validation-field>
      </div>
    </div>

    <div class="columns">
      <div class="column is-2">
        <validation-field label="Email Address" :validation="validation.email_address">
          <b-input v-model="editRa.email_address" placeholder="Email Address" :size="sizeClass" @focus="focussed('email_address')" :disabled="!editable" />
        </validation-field>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <validation-field label="Primary Phone Number" :validation="validation.primary_phone_number">
          <b-input v-model="editRa.primary_phone_number" placeholder="Primary Phone Number" :size="sizeClass" @focus="focussed('primary_phone_number')" :disabled="!editable" />
        </validation-field>
      </div>
      <div class="column">
        <validation-field label="Secondary Phone Number" :validation="validation.secondary_phone_number">
          <b-input v-model="editRa.secondary_phone_number" placeholder="Secondary Phone Number" :size="sizeClass" @focus="focussed('secondary_phone_number')" :disabled="!editable" />
        </validation-field>
      </div>
    </div>

    <h1 class="title is-6">
      Return address you wish to receive your returned product.
    </h1>

    <div class="columns">
      <div class="column">
        <validation-field label="Street (We do not accept PO Boxes)" :validation="validation.street">
          <b-input v-model="editRa.street" :size="sizeClass" @focus="focussed('street')" :disabled="!editable" />
        </validation-field>
      </div>
      <div class="column">
        <validation-field label="Town / Suburb" :validation="validation.suburb">
          <b-input v-model="editRa.suburb" :size="sizeClass" @focus="focussed('suburb')" :disabled="!editable" />
        </validation-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <validation-field label="State" :validation="validation.state">
          <b-select v-model="editRa.state" placeholder="Select a state" :size="sizeClass" @focus="focussed('state')" :disabled="!editable" expanded>
            <option v-for="item in states" :value="item" :key="item">{{ item }}</option>
          </b-select>
        </validation-field>
      </div>
      <div class="column">
        <validation-field label="Postcode" :validation="validation.postcode">
          <b-input type="number" maxlength="4" v-model="editRa.postcode" :size="sizeClass" @focus="focussed('postcode')" :disabled="!editable" />
        </validation-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <template v-if="!express">
          <validation-field label=" - Please provide us accurate information on the issues you are having with your product" />
          <validation-field label=" - Please describe your issues in a dot point manner, Precise and to the point." />
        </template>
        <validation-field label="Issue" :validation="validation.issue">
          <b-input type="textarea" v-model="editRa.issue" :size="sizeClass" @focus="focussed('issue')" :disabled="!editable" />
        </validation-field>
      </div>
    </div>

    <template v-if="express">
      <div class="columns">
        <div class="column">
          <validation-field label="Customer to send">
            <b-input type="textarea" v-model="editRa.customer_to_send" :size="sizeClass" />
          </validation-field>
        </div>
        <div class="column">
          <validation-field label="Fault Report">
            <b-input type="textarea" v-model="editRa.fault_report" :size="sizeClass" />
          </validation-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-checkbox v-model="editRa.return">
            Authorise return
          </b-checkbox>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="columns">
        <div class="column">
          <validation-field label="Terms and Conditions" :validation="tncValidation">
          <b-checkbox v-model="tncAgree" :size="sizeClass" :disabled="!editable">
            I have read and accept the terms and conditions
          </b-checkbox>
        </validation-field>

        <validation-field :validation="rcaptValidation" v-if="editable">
          <div v-if="rcaptReady" ref="recaptDiv" class="g-recaptcha" :data-sitekey="rcaptSiteKey"></div>
        </validation-field>
        </div>
      </div>
    </template>

    <div class="columns" v-if="editable">
      <div class="column is-6">
        <b-message title="Error!" type="is-danger" size="is-small" :active.sync="showErr">{{ errMsg }}</b-message>
      </div>
    </div>

    <div class="columns" v-if="editable">
      <div class="column">
        <div class="buttons">
          <button type="submit" class="button" :class="{'is-loading': submitting}">Submit</button>
        </div>
      </div>
    </div>

  </form>
</template>

<script>
import ValidationField from '@/components/ValidationField'
export default {
  name: 'ReturnAuthorisationForm',
  components: {
    ValidationField
  },
  props: {
    ra: { default: null },
    express: { default: false },
    editable: { default: true }
  },
  data () {
    return {
      editRa: null,
      products: [],
      dealers: [],
      states: ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'],
      sizeClass: 'is-small',
      product: '',
      selectedProduct: '',
      dealer: '',
      selectedDealer: '',
      datePurchased: null,
      tncAgree: false,
      errMsg: '',
      showErr: false,
      submitting: false,
      validation: {
        product: { msg: '' },
        dealer: { msg: '' },
        invoice_number: { msg: '' },
        date_purchased: { msg: '', type: 'date', format: 'YYYY-MM-DD' },
        first_name: { msg: '' },
        family_name: { msg: '' },
        street: { msg: '' },
        suburb: { msg: '' },
        state: { msg: '' },
        postcode: { msg: '', type: 'chars', length: 4 },
        email_address: { msg: '', type: 'email' },
        primary_phone_number: { msg: '' },
        issue: { msg: '' }
      },
      selectedProductValidation: { msg: '' },
      selectedDealerValidation: { msg: '' },
      tncValidation: { msg: '' },
      rcaptValidation: { msg: '' },
      rcaptSiteKey: '6LdCSX4UAAAAACKZvqxqZ_FYinHLRHI7W2TIoiB1',
      rcaptId: null,
      rcaptReady: false
    }
  },
  watch: {
    tncAgree () { this.tncValidation.msg = '' },
    selectedProduct () {
      this.product = this.selectedProduct === 'Other' ? '' : this.selectedProduct
    },
    selectedDealer () {
      this.dealer = this.selectedDealer === 'Other' ? '' : this.selectedDealer
    }
  },
  created () {
    this.prepareRa()
    this.$api('getRaFormData')
      .then(resp => {
        this.products = resp.products
        this.dealers = resp.dealers
        this.products.push({ id: -1, name: 'Other' })
        this.dealers.push({ id: -2, name: 'Other' })
        this.matchProduct()
        this.matchDealer()
      })
  },
  mounted () {
    if (!this.express) {
      this.rcaptReady = true
      setTimeout(this.initGrecaptcha, 1000)
    }
  },
  methods: {
    initGrecaptcha () {
      if (this.rcaptId !== null) return
       this.rcaptId = grecaptcha.render( this.$refs.recaptDiv, { // eslint-disable-line
        sitekey: this.rcaptSiteKey,
        callback: resp => {
          if (resp.length) {
            this.rcaptValidation.msg = ''
          }
        }
      })
    },
    validateForm () {
      if (this.express) {
        return true
      }
      let formValid = this.$utils.validate(this.validation, this.editRa)
      if (!this.selectedProduct || !this.selectedProduct.length) {
        this.selectedProductValidation.msg = '* required'
      }

      if (!this.tncAgree) {
        this.tncValidation.msg = 'must agree to terms and conditions'
      }

      let rcaptKey = grecaptcha.getResponse(this.rcaptId !== null ? this.rcaptId : 0) // eslint-disable-line no-undef
      this.rcaptValidation.msg = rcaptKey.length ? '' : 'Are you a human?'

      return formValid && this.tncAgree && rcaptKey.length
    },
    submit () {
      if (this.submitting) {
        return
      }

      this.editRa.product = this.product
      this.editRa.dealer = this.dealer
      this.editRa.date_purchased = this.datePurchased ? this.$moment(this.datePurchased).format('YYYY-MM-DD') : '0000-00-00'
      if (!this.validateForm()) {
        this.errMsg = 'Could not submit return authorisation. Please check all form inputs are valid.'
        this.showErr = true
        return
      }

      this.errMsg = ''
      this.showErr = false

      this.submitting = true
      let req = {
        return: this.editRa,
        express: this.express
      }
      this.$api(this.ra ? 'update_return' : 'submit_return', req)
        .then(resp => {
          this.submitting = false
          this.$emit('submitted')
        })
        .catch(err => {
          this.errMsg = 'Could not submit return authorisation. An unknown erros has occured. Please try again later.'
          this.showErr = true
          this.submitting = false
          console.error(err)
        })
    },
    prepareRa () {
      this.editRa = Object.assign(this.getBlankRa(), this.ra || {})
      this.datePurchased = this.getDate(this.editRa.date_purchased)
      if (!this.editRa.date_received) {
        this.editRa.date_received = '0000-00-00'
      }
      if (!this.editRa.date_sent) {
        this.editRa.date_sent = '0000-00-00'
      }
      this.matchProduct()
      this.matchDealer()
    },
    matchProduct () {
      if (this.products.length && this.editRa && this.editRa.product && this.editRa.product.length) {
        this.product = this.editRa.product
        if (!this.products.find(item => item.name === this.product)) {
          this.selectedProduct = 'Other'
          setTimeout(() => {
            this.product = this.editRa.product
          }, 500)
        } else {
          this.selectedProduct = this.product
        }
      } else {
        this.selectedProduct = null
      }
    },
    matchDealer () {
      if (this.dealers.length && this.editRa && this.editRa.dealer && this.editRa.dealer.length) {
        this.dealer = this.editRa.dealer
        if (!this.dealers.find(item => item.name === this.product)) {
          this.selectedDealer = 'Other'
          setTimeout(() => {
            this.dealer = this.editRa.dealer
          }, 500)
        } else {
          this.selectedDealer = this.dealer
        }
      } else {
        this.selectedDealer = null
      }
    },
    getDate (str) {
      if (str.indexOf('0000-00-00') === 0) {
        return null
      } else {
        return this.$moment(str).toDate()
      }
    },
    focussed (k) {
      if (this.validation[k]) {
        this.validation[k].msg = ''
      }
    },
    getBlankRa () {
      return {
        id: null,
        product: null,
        serial_number: '',
        invoice_number: '',
        first_name: '',
        family_name: '',
        street: '',
        suburb: '',
        state: null,
        postcode: '',
        email_address: '',
        primary_phone_number: '',
        secondary_phone_number: '',
        dealer: null,
        customer_type: 'customer',
        issue: '',
        date_purchased: '0000-00-00',
        date_received: '0000-00-00',
        date_sent: '0000-00-00',
        return: 0,
        customer_to_send: '',
        fault_report: '',
        replaced_serial: '',
        tracking_num: '',
        shipping_method: '',
        status: 1
      }
    }
  }
}
</script>

<style>

</style>
